module.exports = __webpack_public_path__ + "img/down5-en.d65a3208.png";